/* eslint-disable no-param-reassign */
import paymentTransactionService from "src/services/paymentTransactionService";

export const GET_PAYMENT_TRANSACTIONS_REQUEST =
  "@paymentTransaction/get-payment-transactions-request";
export const GET_PAYMENT_TRANSACTIONS_SUCCESS =
  "@paymentTransaction/get-payment-transactions-success";
export const GET_PAYMENT_TRANSACTIONS_FAILURE =
  "@paymentTransaction/get-payment-transactions-failure";

export const CREATE_PAYMENT_TRANSACTION_REQUEST =
  "@paymentTransaction/CREATE-payment-transaction-request";
export const CREATE_PAYMENT_TRANSACTION_SUCCESS =
  "@paymentTransaction/CREATE-payment-transaction-success";
export const CREATE_PAYMENT_TRANSACTION_FAILURE =
  "@paymentTransaction/CREATE-payment-transaction-failure";

export function getListPaymentTransactions(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_PAYMENT_TRANSACTIONS_REQUEST});
      const response = await paymentTransactionService.getListPaymentTransactions(data);
      dispatch({
        type: GET_PAYMENT_TRANSACTIONS_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_PAYMENT_TRANSACTIONS_FAILURE});
      throw error;
    }
  };
}

export function createPaymentTransaction(data) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_PAYMENT_TRANSACTION_REQUEST});
      const response = await paymentTransactionService.createPaymentTransaction(data);
      dispatch({
        type: CREATE_PAYMENT_TRANSACTION_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: CREATE_PAYMENT_TRANSACTION_FAILURE});
      throw error;
    }
  };
}
